import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, verifyToken } from '../../utils/auth';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading]           = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      if (!isAuthenticated()) { setLoading(false); return; }
      const valid = await verifyToken();
      setAuthenticated(valid);
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ backgroundColor: '#EAEFEF' }}>
        <div className="text-center">
          <div
            className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-t-transparent"
            style={{ borderColor: '#FF9B51', borderTopColor: 'transparent' }}
          />
          <p className="mt-4 text-sm font-medium" style={{ color: '#BFC9D1' }}>Loading…</p>
        </div>
      </div>
    );
  }

  return authenticated ? children : <Navigate to="/admin/login" replace />;
};

export default ProtectedRoute;
